// extracted by mini-css-extract-plugin
export default {"videoPlayerWrapper":"VideoPlayerModal_videoPlayerWrapper__7yQjw"};